import type { EventTypeView } from '@ps/web-sports-api-types';

import type { Event as FullEvent } from '@swf/sports/components/Event/types';
import type { EventTypeId } from '@swf/sports/types/eventType';
import type { EventBasedMarketTemplatesView } from '@swf/sports/types/templates';
import { notEmpty } from '@swf/sports/utils/notEmpty';

const getEventsFromMarketTemplateData = (
  events: EventBasedMarketTemplatesView['events'],
  markets: EventBasedMarketTemplatesView['markets'],
  competitions: EventBasedMarketTemplatesView['competitions'],
  eventTypes: EventBasedMarketTemplatesView['eventTypes']
): FullEvent[] => {
  const marketArray = Object.values(markets);

  return Object.entries(events)
    .map(([eventId, event]) => {
      const parsedEventId: EventTypeId = Number(eventId);
      const eventMarket = marketArray.find((mkt) => mkt?.eventId === parsedEventId);
      if (!eventMarket) return null;
      if (!eventMarket.competitionId) return null;

      const { competitionSlug } = competitions[eventMarket.competitionId];
      const { eventTypeId, eventTypeSlug } = eventTypes[eventMarket.eventTypeId] as EventTypeView;
      return {
        ...event,
        eventTypeId,
        eventTypeSlug,
        competitionSlug,
        competitionId: eventMarket.competitionId,
        startTime: event.eventStartTime,
        eventId: parsedEventId,
        market: eventMarket
      };
    })
    .filter(notEmpty);
};

export default getEventsFromMarketTemplateData;
